import { IAuthor } from './i-author';

export interface IAuthorResponse {
  results: IAuthor[];
  totalCount: number;
}
export class AuthorResponse implements IAuthorResponse {
  constructor(
    public results: IAuthor[] = [],
    public totalCount: number = 0,
  ) {}
}
